import React from 'react';
import { Redirect } from 'react-router-dom';
import { EditOrganizationForm } from '../../components/organization-management/organization-form/edit-organization-form';
import { useAuthState } from '../../utilities/contexts/auth-state-context';
import UserUtil from '../../utilities/user-util';
import OrganizationUtil from '../../utilities/organization-util';
import { EditSubOrganizationForm } from '../../components/organization-management/edit-sub-organization-form/edit-sub-organization-form';

type AddAccountModalProps = {
};

export const AddOrganizationPage: React.FC<AddAccountModalProps> = (props: AddAccountModalProps) => {

    const { state } = useAuthState();
    const isAccountHolder = UserUtil.isAccountHolder(state.user);
    const isSuperAdmin = state.claims?.superAdmin === true;

    // Only super admins may create regular organizations; account holders may
    // create sub-organizations when their plan supports them. Guard direct
    // navigation, not just the nav item.
    if (!isSuperAdmin && (!isAccountHolder || !OrganizationUtil.supportsSubOrganizations(state.organization))) {
        return <Redirect push to="/" />;
    }

    return (
        <div style={{ maxWidth: '1000px' }}>
            {
                isAccountHolder
                    ? (
                        <EditSubOrganizationForm
                            redirect={"/organizations"}
                        />
                    )
                    : (
                        <EditOrganizationForm
                            redirect={"/organizations"}
                        />
                    )
            }

        </div>
    );
}